import React, { useEffect, useState } from 'react';
import { ImageMappingForDragAndDrop } from '../Data/ImageMapping';

interface IFilesUploadingLayout {
    filename: string;
    fileExtension?: string;
    fileSize: number;
    onDelete: () => void; // Add onDelete function prop
}

const FilesUploadingLayout: React.FC<IFilesUploadingLayout> = ({ filename, fileExtension, fileSize, onDelete }) => {
    const [progressPercentage, setProgressPercentage] = useState<number>(0);

    useEffect(() => {
        const maxFileSize = fileSize;
        const interval = setInterval(() => {
            setProgressPercentage(prevPercentage => {
                const newPercentage = prevPercentage + 1;
                return newPercentage > 100 ? 100 : newPercentage;
            });
        }, 20);

        return () => clearInterval(interval);
    }, [fileSize]);

    const getImageSource = (fileExtension: string): string => {
        const imageMapping: { [key: string]: string } = {
            'csv': ImageMappingForDragAndDrop.IMAGE_CSV,
            'doc': ImageMappingForDragAndDrop.IMAGE_DOC,
            'jpg': ImageMappingForDragAndDrop.IMAGE_JPG,
            'pdf': ImageMappingForDragAndDrop.IMAGE_PDF,
            'png': ImageMappingForDragAndDrop.IMAGE_PNG,
        };
      
        return imageMapping[fileExtension.toLowerCase()] || '';
    };

    return (
        <div className='d-flex justify-content-between filesUpload p-3 align-items-center '>
            {/* LOGO */}
            <img src={getImageSource(fileExtension || '')} alt={fileExtension} className='me-3'/>

            {/* File Name and the progress bar */}
            <div className='col'>
                <div className="d-flex justify-content-between percentage-div mb-2">
                <div>{filename}</div>
                <div>
                {progressPercentage}%
                </div>
                </div>
                <div className="progress" style={{ height: '3px' }}>
                    <div className="progress-bar bg-success" role="progressbar" style={{ width: `${progressPercentage}%` }} 
                    aria-valuenow={progressPercentage} aria-valuemin={0} aria-valuemax={100}></div>
                </div>
            </div>
            {/* Progress percentage */}
            
            {/* DELETE */}
            <div className="col-auto ms-4" onClick={onDelete}><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8z" />
            </svg>
            </div> {/* Add onClick event to trigger onDelete function */ }
        </div >
    );
};

export default FilesUploadingLayout;
